import React from "react";
import { SimpleButtonProps } from "./simple-button-dto";
import { StyledSimpleButton } from "./simple-button-style";

const SimpleButton = (props: SimpleButtonProps) => {
  return (
    <StyledSimpleButton onClick={props.onClick}>
      <img src={props.icon} alt={props.alt} />
      {props.text}
    </StyledSimpleButton>
  );
};

export default SimpleButton;
